
export enum EnumSituacaoContrato {
    OK = 0,
    BLOQUEADO = 1,
    CANCELADO = 2,
    SUSPENSO = 3,
}
